import { render, staticRenderFns } from "./ResultsCard.vue?vue&type=template&id=3a2e7a74&scoped=true"
import script from "./ResultsCard.vue?vue&type=script&lang=js"
export * from "./ResultsCard.vue?vue&type=script&lang=js"
import style0 from "./ResultsCard.vue?vue&type=style&index=0&id=3a2e7a74&prod&lang=css"
import style1 from "./ResultsCard.vue?vue&type=style&index=1&id=3a2e7a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e7a74",
  null
  
)

export default component.exports